import React, { useEffect, useState } from "react";

const BlogList = ({ rangeDays = 7 }) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = new URL(
          "https://qyoalrnfq7dksm6iat5lqsb4oi0pawfb.lambda-url.us-east-1.on.aws/"
        );
        url.searchParams.append("range_days", rangeDays);
        const response = await fetch(url.toString());
        if (!response.ok) {
          throw new Error(`API error: ${response.status}`);
        }
        const data = await response.json();
        setBlogs(data.blogs || []);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [rangeDays]);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-10 text-center">
        <p className="text-gray-500">Loading latest articles…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-10 text-center">
        <p className="text-red-600">Error: {error}</p>
      </div>
    );
  }

  return (
    <section className="py-12 bg-gray-50 sm:py-16 lg:py-20">
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="max-w-5xl mx-auto">
          <div className="max-w-md mx-auto lg:flex lg:items-center lg:justify-between lg:max-w-none">
            <h2 className="max-w-xs text-3xl font-bold text-gray-900 sm:text-4xl">
              Latest Articles
            </h2>
            <p className="max-w-xs mt-4 text-sm font-normal leading-6 text-gray-500 lg:mt-0">
              Browse our most recent posts, updated every day.
            </p>
          </div>

          <div className="flow-root max-w-md mx-auto mt-12 border-t border-gray-200 sm:mt-16 lg:max-w-none">
            <div className="-mb-10 divide-y divide-gray-200">
              {blogs.map((blogItem, idx) => {
                // Convert the raw S3 URL into the public CloudFront URL:
                const urlObj = new URL(blogItem.url);
                // urlObj.pathname is like "/blogs/MyPost.html"
                const publicPath = urlObj.pathname.replace(/^\/blogs/, "");
                const publicUrl = `https://blogs.precisedraft.ai${publicPath}`;

                return (
                  <div
                    key={idx}
                    className="grid grid-cols-1 py-10 gap-y-6 lg:grid-cols-8 lg:gap-x-32"
                  >
                    {/* Date Column */}
                    <div className="lg:col-span-2">
                      <p className="text-sm font-medium text-gray-500">
                        {blogItem.date}
                      </p>
                    </div>

                    {/* Title Column */}
                    <div className="lg:col-span-4">
                      <p className="text-2xl font-bold text-gray-900">
                        <a
                          href={publicUrl}
                          title={blogItem.topic}
                          className="hover:underline"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {blogItem.topic}
                        </a>
                      </p>
                    </div>

                    {/* Learn More Column */}
                    <div className="lg:col-span-2 text-right">
                      <a
                        href={publicUrl}
                        title="Read More"
                        className="inline-flex items-center text-xs font-bold tracking-widest text-gray-900 uppercase group"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Learn More
                        <svg
                          className="w-4 h-4 ml-2 transition-all duration-200 transform group-hover:translate-x-1"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M13 7l5 5m0 0l-5 5m5-5H6"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogList;
